declare global {
  interface Window {
    AmazonTakt: any
  }
}

export const taktId = (widgetType: string, anchorId: string, isMobile = false) => {
  const deviceType = isMobile ? 'mobile' : 'desktop'
  return `FIT_${widgetType}_${deviceType}_${anchorId}`
}

export const logWithTakt = (context: string, details: unknown): void => {
  if (window?.AmazonTakt) {
    window.AmazonTakt.logCustom({
      context,
      details: JSON.stringify(details),
    })
  }
}

export const getTakt = ():
  | undefined
  | {
      session_id: string
      visit_id: string
    } => {
  return window?.AmazonTakt
}
